export default __webpack_public_path__ + "static/media/arrow.415af7d6.png";